export const BRANDING = {
  productName: 'Mindy SRE AI Agent',
  shortName: 'Mindy',
  vendor: 'Mindwalker',
  productCode: 'MOPS-SREI',
  tagline: 'AI-Native SRE Agent for Investigation and Unified Operations',
  supportUrl: 'https://mindwalker.ai/support',
  docsUrl: 'https://mindwalker.ai/docs',
} as const;

export type Branding = typeof BRANDING;
